import { Component, OnInit } from '@angular/core';
import { TranslationLoaderFacade } from '../../localization/translation-loader.facade';

@Component({
  selector: 'app-tenant-widget-settings',
  templateUrl: './tenant-widget-settings.component.html',
  styleUrls: ['./tenant-widget-settings.component.scss']
})
export class TenantWidgetSettingsComponent implements OnInit {

  constructor(private translationLoaderFacade: TranslationLoaderFacade) { }

  ngOnInit() {
  }

}
